<div>
  <app-header class="d-md-none"></app-header>
  <div class="main-banner" style="position: relative">
    <div class="main-chat-container">
      <div class="row px-0 px-md-4 pt-0 pt-md-2 pb-2 chat-window justify-content-between">
        <div [class]="getSidebarClass()" [ngClass]="{ 'd-none': shouldHideSidebar() }">
          <div style="max-width: 100%; height: 100%">
            <div [hidden]="showAdvancedSearchFilters" style="height: 100%">
              <app-chat-sidebar #chatSidebar [chatListLoading]="chatListLoading"
                [skeletonPlaceholders]="skeletonPlaceholders" [allSingleUsers]="allSingleUsers"
                [allGroupUsers]="allGroupUsers" [sortedChats]="sortedChats" [chatMap]="chatMap"
                [userNameMapping]="userNameMapping" [profileImageMapping]="profileImageMapping"
                [userId]="userId" [selectedChatUserId]="selectedChatUserId"
                [activeChannel]="activeChannel" [memberChannelId]="memberChannelId" [isMobileView]="isMobileView"
                [showChatWindow]="showChatWindow" [showcount]="showcount" [profileImg]="profileImg"
                [typingUsers]="typingUsers" (chatSelected)="onChatSelected($event)"
                (openCreateGroupModal)="openCreateGroupModal()" (openAdvancedSearch)="toggleAdvancedSearch()"
                (openStarred)="toggleStarredMessages()" [starredMessages]="starredMessages"
                (starredMessageSelected)="goToStarredMessage($event)"
                (togglePin)="toggleChatPin($event)"></app-chat-sidebar>
            </div>
            <div [hidden]="!showAdvancedSearchFilters" style="height: 100%">
              <app-advanced-search #advancedSearch [userId]="userId" [isMobileView]="isMobileView"
                [showResultsOnMobile]="showMobileSearchResults" (close)="closeAdvancedSearch()"
                (searchResults)="onAdvancedSearchResults($event)" (loading)="isSearchLoading = $event"
                (selectChat)="onChatSelected($event)" (openPreview)="onOpenMediaPreview($event)"
                (backToFilters)="showMobileSearchResults = false"></app-advanced-search>
            </div>
          </div>
        </div>

        <div [class]="getChatWindowClass()" [ngClass]="{ 'd-none': shouldHideChatWindow() }">
          @if (!isMobileView && showAdvancedSearchResults) {
          <app-search-results [results]="advancedSearchResults" [matchesCount]="advancedSearchMatches"
            [filters]="advancedSearchFilters" [isLoading]="isSearchLoading" (selectChat)="onChatSelected($event)"
            (scrolled)="onSearchResultsScrolled()" (openPreview)="onOpenMediaPreview($event)"
            (closeResults)="closeAdvancedSearch()"></app-search-results>
          } @else if (showStarredMessages) {
          <div class="starred-messages-container common-mg">
            <div class="starred-header d-flex align-items-center p-3 border-bottom">
              <button class="btn btn-icon mr-2" (click)="toggleStarredMessages()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
              <h4 class="mb-0">Starred</h4>
            </div>

            <div class="starred-body-global py-3" style="overflow-y: auto; flex: 1;" (scroll)="onStarredScroll($event)">
              @if (starredMessages.length === 0 && !isStarredLoading) {
              <div class="text-center mt-5">
                <div class="empty-star-icon mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
                    stroke="#ccc" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <polygon
                      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                    </polygon>
                  </svg>
                </div>
                <p class="text-muted">No starred messages yet.</p>
              </div>
              }

              <div class="starred-list-global">
                @for (message of starredMessages; track (message._id || message.id || i); let i = $index) {
                <div class="starred-message-item-global mb-3 px-3" (click)="goToStarredMessage(message)">
                  <div class="d-flex w-100 position-relative">
                    <!-- Avatar -->
                    <div class="avatar-col mr-3">
                      <img
                        [src]="profileImageMapping[message.message?.sender_id] || profileImageMapping[message.sender_id] || 'assets/user-icon.png'"
                        class="rounded-circle" width="30" height="30" (error)="handleProfileImageError($event)">
                    </div>

                    <!-- Content Column -->
                    <div class="content-col flex-grow-1 min-width-0">
                      <!-- Header Row -->
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <div class="sender-info text-truncate mr-2">
                          <span class="sender-name font-weight-bold">
                            {{ message.message?.sender_id === userId ? 'You' :
                            (userNameMapping[message.message?.sender_id] ||
                            message.message?.name || 'User') }}
                          </span>
                          <span class="chat-separator mx-1 text-muted"> - </span>
                          <span class="chat-target-name text-muted">{{ getChatName(message) }}</span>
                        </div>
                        <div class="time-col">
                          <small class="text-muted white-space-nowrap">{{ message.createdAt | date:'h:mm a' }}</small>
                          <i class="fa fa-angle-right ml-2 text-muted small"></i>
                        </div>
                      </div>

                      <!-- Bubble Row -->
                      <div class="bubble-row">
                        <div class="message-bubble" [class.sender]="message.message?.sender_id === userId">
                          <!-- Forwarded Indicator -->
                          @if ((message.message || message).meta?.isForwarded) {
                          <div class="forwarded-indicator d-flex justify-content-start align-items-center mb-1"
                            [class.sender]="userId === (message.message || message).sender_id">
                            <svg style="margin-right: 4px" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                              viewBox="0 0 24 24">
                              <path fill="currentColor"
                                d="m15 5l-1.41 1.41L18.17 11H2V13h16.17l-4.59 4.59L15 19l7-7z" />
                            </svg>
                            <p class="forwarded-text mb-0">Forwarded from {{ (message.message ||
                              message).meta?.forwardedFrom || 'Unknown' }}</p>
                          </div>
                          }


                          @if (getFilesFromMessage(message).length > 1) {
                          <div class="files-carousel-container">

                            <div class="carousel-wrapper">
                              <div class="carousel-inner">
                                @for (file of getFilesFromMessage(message); track file.fileUrl; let j =
                                $index) {
                                <div class="carousel-item" [class.active]="(message.currentSlideIndex || 0) === j">
                                  @if (file.type?.startsWith('image/')) {
                                  <div class="image-box">
                                    <img [src]="file.fileUrl" (error)="handleMediaError($event, message)"
                                      class="starred-thumb" />
                                  </div>
                                  }
                                  @if (file.type?.startsWith('video/')) {
                                  <div class="video-box">
                                    <video [src]="file.fileUrl" class="starred-thumb"
                                      poster="assets/video-file.jpg"></video>
                                  </div>
                                  }
                                  @if (file.type?.startsWith('audio/') || isVoiceMessage(file.fileUrl)) {
                                  <div
                                    class="starred-audio-player voice-message-ui p-2 rounded d-flex align-items-center"
                                    [class.sender]="message.message?.sender_id === userId">
                                    <div class="audio-main d-flex align-items-center justify-content-center w-100">
                                      <!-- Avatar -->
                                      <div class="voice-avatar-container mr-2">
                                        <img
                                          [src]="message.message?.sender_id === userId ? (profileImageMapping[userId] || 'assets/user-icon.png') : (profileImageMapping[message.sender_id] || 'assets/user-icon.png')"
                                          class="voice-avatar-img">
                                        <div class="voice-mic-icon">
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                                            <path
                                              d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                            <path
                                              d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                                          </svg>
                                        </div>
                                      </div>

                                      <!-- Play Button -->
                                      <button class="audio-play-btn mr-1 mb-2" (click)="togglePlay($event, message)">
                                        <i class="fa"
                                          [class.fa-pause]="currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused"
                                          [class.fa-play]="!(currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused)"></i>
                                      </button>

                                      <!-- Audio Info (Waveform + Time) -->
                                      <div class="audio-info flex-grow-1 min-width-0">
                                        <div class="voice-scrubber-wrapper position-relative" style="min-width: 120px;">
                                          <!-- Unfilled -->
                                          <div
                                            class="fake-waveform unfilled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                            style="gap: 2px;">
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                          </div>
                                          <!-- Filled -->
                                          <div
                                            class="fake-waveform filled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                            [style.--percent]="audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0"
                                            style="gap: 2px; z-index: 2;">
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="wave-bar" style="height: 40%"></div>
                                            <div class="wave-bar" style="height: 80%"></div>
                                            <div class="wave-bar" style="height: 50%"></div>
                                            <div class="wave-bar" style="height: 100%"></div>
                                            <div class="wave-bar" style="height: 70%"></div>
                                            <div class="wave-bar" style="height: 30%"></div>
                                            <div class="wave-bar" style="height: 90%"></div>
                                            <div class="wave-bar" style="height: 60%"></div>
                                            <div class="waveform-thumb"
                                              [style.left]="'calc(' + ((audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0) * 100) + '% - 4px)'">
                                            </div>
                                          </div>
                                        </div>
                                        <div class="voice-meta-row mt-1">
                                          <span class="voice-duration text-muted" style="font-size: 11px;">
                                            {{ currentlyPlayingId === (message.messageId || message._id || message.id) ?
                                            formatDuration(audioProgress[message.messageId || message._id ||
                                            message.id]?.currentTime || 0) :
                                            formatDuration((message.message || message).meta?.duration || 0) }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  }
                                  @if (!file.type?.startsWith('image/') && !file.type?.startsWith('video/') &&
                                  !file.type?.startsWith('audio/')) {
                                  <div
                                    class="starred-document-box-new d-flex align-items-center justify-content-between p-2 rounded">
                                    <span class="starred-file-name-new text-truncate mr-2">{{ file.name }}</span>
                                    <div class="starred-download-circle">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        viewBox="0 0 16 16">
                                        <path
                                          d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                        <path
                                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                      </svg>
                                    </div>
                                  </div>
                                  }
                                </div>
                                }
                              </div>

                              <div class="carousel-controls">
                                <button class="carousel-control prev"
                                  (click)="prevSlide(message); $event.stopPropagation()">
                                  <i class="fa fa-angle-left"></i>
                                </button>
                                <div class="carousel-indicators">
                                  <span>{{ (message.currentSlideIndex || 0) + 1 }} / {{
                                    getFilesFromMessage(message).length }}</span>
                                </div>
                                <button class="carousel-control next"
                                  (click)="nextSlide(message); $event.stopPropagation()">
                                  <i class="fa fa-angle-right"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          } @else if (getFilesFromMessage(message).length === 1) {
                          @let file = getFilesFromMessage(message)[0];
                          <div class="starred-single-file-container mt-2"
                            [class.no-margin]="!(message.message?.message || message.msg)">
                            @if (file.type?.startsWith('image/')) {
                            <img [src]="file.fileUrl" (error)="handleMediaError($event, message)"
                              class="starred-thumb" />
                            } @else if (file.type?.startsWith('video/')) {
                            <div class="video-preview">
                              <video [src]="file.fileUrl" controls muted playsinline preload="auto"
                                class="starred-thumb"></video>
                            </div>
                            } @else if (file.type?.startsWith('audio/') || isVoiceMessage(file.fileUrl)) {
                            <div class="starred-audio-player voice-message-ui p-2 rounded d-flex align-items-center"
                              [class.sender]="message.message?.sender_id === userId">
                              <div class="audio-main d-flex align-items-center justify-content-center w-100">
                                <!-- Avatar -->
                                <div class="voice-avatar-container mr-2">
                                  <img
                                    [src]="message.message?.sender_id === userId ? (profileImageMapping[userId] || 'assets/user-icon.png') : (profileImageMapping[message.sender_id] || 'assets/user-icon.png')"
                                    class="voice-avatar-img">
                                  <div class="voice-mic-icon">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                                      <path
                                        d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                      <path
                                        d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                                    </svg>
                                  </div>
                                </div>
                                <!-- Play Button -->
                                <button class="audio-play-btn mr-1 mb-2" (click)="togglePlay($event, message)">
                                  <i class="fa"
                                    [class.fa-pause]="currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused"
                                    [class.fa-play]="!(currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused)"></i>
                                </button>
                                <!-- Audio Info (Waveform + Time) -->
                                <div class="audio-info flex-grow-1 min-width-0">
                                  <div class="voice-scrubber-wrapper position-relative" style="min-width: 120px;">
                                    <!-- Unfilled -->
                                    <div
                                      class="fake-waveform unfilled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                      style="gap: 2px;">
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                    </div>
                                    <!-- Filled -->
                                    <div
                                      class="fake-waveform filled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                      [style.--percent]="audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0"
                                      style="gap: 2px; z-index: 2;">
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="waveform-thumb"
                                        [style.left]="'calc(' + ((audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0) * 100) + '% - 4px)'">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="voice-meta-row mt-1">
                                    <span class="voice-duration text-muted" style="font-size: 11px;">
                                      {{ currentlyPlayingId === (message.messageId || message._id || message.id) ?
                                      formatDuration(audioProgress[message.messageId || message._id ||
                                      message.id]?.currentTime || 0) :
                                      formatDuration((message.message || message).meta?.duration || 0) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            } @else {
                            <div
                              class="starred-document-box-new d-flex align-items-center justify-content-between p-2 rounded mb-1">
                              <span class="starred-file-name-new text-truncate mr-2">{{ file.name || 'Document'
                                }}</span>
                              <div class="starred-download-circle">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                  <path
                                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                </svg>
                              </div>
                            </div>
                            }
                          </div>
                          } @else if (getReplyThumbnail(message) && !hasLinkMeta(message)) {
                          <div class="starred-media-preview mt-2"
                            [class.no-margin]="!(message.message?.message || message.msg)">
                            @if (getReplyMediaType(message) === 'Photo' ||
                            getReplyMediaType(message) === 'GIF') {
                            <img [src]="getReplyThumbnail(message)" (error)="handleMediaError($event, message)"
                              class="starred-thumb" />
                            } @else if (getReplyMediaType(message) === 'Video') {
                            <div class="video-preview">
                              <video
                                [src]="(message.message?.url || message.url || getFilesFromMessage(message)[0]?.fileUrl)"
                                [poster]="getReplyThumbnail(message)" controls muted playsinline preload="auto"
                                class="starred-thumb">
                              </video>
                            </div>
                            } @else if (getReplyMediaType(message) === 'Audio' || getReplyMediaType(message) === 'Voice
                            Message') {
                            <div
                              class="starred-audio-player voice-message-ui p-2 rounded mb-1 d-flex align-items-center"
                              [class.sender]="message.message?.sender_id === userId">
                              <div class="audio-main d-flex align-items-center justify-content-center w-100">
                                <!-- Avatar -->
                                <div class="voice-avatar-container mr-2">
                                  <img
                                    [src]="message.message?.sender_id === userId ? (profileImageMapping[userId] || 'assets/user-icon.png') : (profileImageMapping[message.sender_id] || 'assets/user-icon.png')"
                                    class="voice-avatar-img">
                                  <div class="voice-mic-icon">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                                      <path
                                        d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                      <path
                                        d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                                    </svg>
                                  </div>
                                </div>
                                <!-- Play Button -->
                                <button class="audio-play-btn mr-1 mb-2" (click)="togglePlay($event, message)">
                                  <i class="fa"
                                    [class.fa-pause]="currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused"
                                    [class.fa-play]="!(currentlyPlayingId === (message.messageId || message._id || message.id) && activeAudio && !activeAudio.paused)"></i>
                                </button>
                                <!-- Audio Info (Waveform + Time) -->
                                <div class="audio-info flex-grow-1 min-width-0">
                                  <div class="voice-scrubber-wrapper position-relative" style="min-width: 120px;">
                                    <!-- Unfilled -->
                                    <div
                                      class="fake-waveform unfilled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                      style="gap: 2px;">
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                    </div>
                                    <!-- Filled -->
                                    <div
                                      class="fake-waveform filled d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                                      [style.--percent]="audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0"
                                      style="gap: 2px; z-index: 2;">
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="wave-bar" style="height: 40%"></div>
                                      <div class="wave-bar" style="height: 80%"></div>
                                      <div class="wave-bar" style="height: 50%"></div>
                                      <div class="wave-bar" style="height: 100%"></div>
                                      <div class="wave-bar" style="height: 70%"></div>
                                      <div class="wave-bar" style="height: 30%"></div>
                                      <div class="wave-bar" style="height: 90%"></div>
                                      <div class="wave-bar" style="height: 60%"></div>
                                      <div class="waveform-thumb"
                                        [style.left]="'calc(' + ((audioProgress[message.messageId || message._id || message.id]?.currentTime / audioProgress[message.messageId || message._id || message.id]?.duration || 0) * 100) + '% - 4px)'">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="voice-meta-row mt-1">
                                    <span class="voice-duration text-muted" style="font-size: 11px;">
                                      {{ currentlyPlayingId === (message.messageId || message._id || message.id) ?
                                      formatDuration(audioProgress[message.messageId || message._id ||
                                      message.id]?.currentTime || 0) :
                                      formatDuration((message.message || message).meta?.duration || 0) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            } @else {
                            <div
                              class="starred-document-box-new d-flex align-items-center justify-content-between p-2 rounded mb-1">
                              <span class="starred-file-name-new text-truncate mr-2">{{
                                getFilesFromMessage(message)[0]?.name || 'Document' }}</span>
                              <div class="starred-download-circle">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                  <path
                                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                </svg>
                              </div>
                            </div>
                            }
                          </div>
                          }

                          <!-- Text Caption (Moved to Bottom) -->
                          @if ((message.message?.message || message.msg) && !isMessageRedundantWithFile(message.message
                          || message)) {
                          <div [class.mt-2]="getFilesFromMessage(message).length > 0 || getReplyThumbnail(message)">
                            @if (isURL(message.message?.message || message.msg)) {
                            <div class="url-preview-container"
                              (click)="openUrl(message.message?.message || message.msg); $event.stopPropagation()">
                              <a [href]="message.message?.message || message.msg" target="_blank"
                                rel="noopener noreferrer" class="mb-0 text-break starred-link link-url">
                                {{ message.message?.message || message.msg }}
                              </a>

                              @if (hasLinkMeta(message)) {
                              <div class="telegram-preview-content" [class.icon-mode]="isIconMode(message)">
                                <div class="preview-text-content">
                                  @if (getMessageMeta(message.message || message).title) {
                                  <p class="meta-title">{{ getMessageMeta(message.message || message).title }}</p>
                                  }
                                  @if (getMessageMeta(message.message || message).description) {
                                  <p class="meta-description">{{ getMessageMeta(message.message || message).description
                                    }}</p>
                                  }
                                </div>

                                @if (isIconMode(message)) {
                                <div class="icon-image-container">
                                  <img [src]="getMessageMeta(message.message || message).icon"
                                    (error)="onPreviewIconError(message)" class="icon-thumbnail" />
                                </div>
                                }

                                @if (getMessageMeta(message.message || message).image &&
                                isValidImageUrl(getMessageMeta(message.message || message).image) &&
                                !getMessageMeta(message.message || message).imageBroken && !isIconMode(message)) {
                                <div class="preview-image-container">
                                  <img [src]="getMessageMeta(message.message || message).image"
                                    (error)="onPreviewImageError(message)" class="telegram-thumbnail" />
                                </div>
                                }
                              </div>
                              }
                            </div>
                            } @else {
                            <p class="mb-0 text-break"
                              [innerHTML]="getDisplayMessage((message.message?.message || message.msg || message.message?.meta?.caption), (message.messageId || message._id || message.id))">
                            </p>
                            @if (isMessageLong(message.message?.message || message.msg ||
                            message.message?.meta?.caption)) {
                            <span class="read-more-link"
                              (click)="toggleMessageExpand(message.messageId || message._id || message.id); $event.stopPropagation()">
                              {{ isMessageExpanded(message.messageId || message._id || message.id) ? ' Show less' : '
                              Read more' }}
                            </span>
                            }
                            }
                          </div>
                          }


                          <!-- Footer in bubble -->
                          <div class="bubble-footer d-flex align-items-center justify-content-end mt-1">
                            <svg class="starred-tiny-icon mr-1" viewBox="0 0 24 24" width="12" height="12"
                              style="color: #ffb800;">
                              <path fill="currentColor"
                                d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z">
                              </path>
                            </svg>
                            <small class="text-muted tiny-time">{{ message.createdAt | date:'h:mm a' }}</small>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- Unstar button absolute -->
                    <button class="unstar-button-abs-global"
                      (click)="unStarMessageAction(message); $event.stopPropagation()" title="Unstar"
                      style="position: absolute; top: 0; right: 40px; background: transparent; border: none; padding: 5px; opacity: 0; transition: opacity 0.2s;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#ffb800"
                          d="m12 17.27l4.15 2.51l-1.1-4.73L18.5 11.7l-4.77-.41L12 7l-1.73 4.29l-4.77.41l3.45 3.37l-1.1 4.73z" />
                      </svg>
                    </button>
                  </div>
                </div>
                }
              </div>

              @if (isStarredLoading) {
              <div class="text-center p-3">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
              </div>
              }
            </div>
          </div>
          } @else if (!singleChatBox && !groupChatBox) {
          <div class="chat-image-banner">
            <img src="../../assets/default-chat-img.png" alt="" />
            <h2>Enjoy the effortless <span>Conversation</span> with Link Chat</h2>
            <p>It's <span>Easy</span> and <span>Free</span> you'll find everything you're looking for here</p>
          </div>
          }
          <!-- SINGLE CHAT BOX CONTAINER -->
          @if (singleChatBox && (!showAdvancedSearchResults || isMobileView) && !showStarredMessages) {
          <div class="common-mg">
            <app-chat-header [title]="singleChatUsername" [status]="chatUserStatus" [image]="singleUserProfileImg"
              [isOnline]="isChatUserOnline" [showMenu]="showChatMenuDropdown" [isGroup]="false"
              [connectionStatus]="chatConnectionStatus"
              [hasMessages]="singleChatMessages && singleChatMessages.length > 0"
              [typingUsers]="getCurrentTypingUsers()"
              [showSearchBackButton]="isLastNavAdvancedSearch || isNavigatedFromStarred" [showClickForInfo]="true"
              (searchBack)="handleSearchBack()" (back)="closeChatWindow()" (toggleMenu)="toggleChatWindowMenu()"
              (openInfo)="openGroupInfoModal()" (clearChat)="clearChat()" (starredClick)="toggleStarredMessagesPanel()"
              (quickSearch)="toggleQuickSearch()" (exportChat)="exportChatHistory($event)">
            </app-chat-header>
            <div class="chat-content">
              <!-- Single Chat Box -->

              @if (pinnedMessages && pinnedMessages.length > 0) {
              @if (!showPinnedMessages) {
              <div class="pinned-messages-bar" (click)="togglePinnedMessages()">
                <div style="display: flex; align-items: center; gap: 10px; overflow: hidden;">
                  <span style="font-size: 16px">
                    <svg (click)="togglePinnedMessages()" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                      viewBox="0 0 24 24">
                      <path fill="#dc3545" d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2z" />
                    </svg>
                  </span>
                  <div style="display: flex; flex-direction: column">
                    <span style="font-weight: bold; font-size: 12px; color: #008069;">
                      {{ pinnedMessages.length }} Pinned Message{{ pinnedMessages.length > 1 ? "s" : "" }}
                    </span>
                    @if (getPinnedMessageText(pinnedMessages[pinnedMessages.length - 1]) === '🎤 Voice message') {
                    <span
                      style="font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px; color: #3b4a54; display: flex; align-items: center; gap: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" style="color: #25D366;">
                        <path fill="currentColor"
                          d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path fill="currentColor"
                          d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                      Voice message {{ getVoiceDuration(pinnedMessages[pinnedMessages.length - 1]) }}
                    </span>
                    } @else {
                    <span
                      style="font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px; color: #3b4a54;">
                      {{ getPinnedMessageText(pinnedMessages[pinnedMessages.length - 1]) }}
                    </span>
                    }
                  </div>
                </div>
                <div style="font-size: 12px; color: #666; display: flex; align-items: center; gap: 5px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
                    <path fill="#000000" d="m7 10l5 5l5-5z" />
                  </svg>
                </div>
              </div>
              }

              @if (showPinnedMessages) {
              <div class="pinned-list">
                <div class="pinned-close"
                  style="position: sticky; top: 0; float: right; margin: 5px; padding: 2px; cursor: pointer; z-index: 1002; background: #eee; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                  (click)="togglePinnedMessages(); $event.stopPropagation()" title="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#666" viewBox="0 0 16 16">
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </div>
                @for (msg of pinnedMessages; track (msg._id || msg.id || msg.messageId || $index)) {
                <div
                  style="padding: 10px; border-bottom: 1px solid #eee; cursor: pointer; display: flex; justify-content: space-between; align-items: center; clear: right;"
                  (click)="scrollToMessage(getPinnedMessageId(msg))">
                  <div>
                    @if (getPinnedMessageText(msg) === '🎤 Voice message') {
                    <div class="pin-txt"
                      style="font-size: 12px; color: #333; display: flex; align-items: center; gap: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" style="color: #25D366;">
                        <path fill="currentColor"
                          d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path fill="currentColor"
                          d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                      Voice message {{ getVoiceDuration(msg) }}
                    </div>
                    } @else {
                    <div class="pin-txt" style="font-size: 12px; color: #333">{{ getPinnedMessageText(msg) }}</div>
                    }
                    <div style="font-size: 10px; color: #999">{{ msg.createdAt | date: "shortTime" }}</div>
                  </div>
                  <div (click)="unpinMessageAction(msg); $event.stopPropagation()" style="padding: 5px; color: #666"
                    title="Unpin">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                      <path fill="#dc3545"
                        d="m20.971 17.172l-1.414 1.414l-3.535-3.535l-.073.074l-.707 3.535l-1.415 1.415l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243l1.414-1.414l3.536-.707l.073-.074l-3.536-3.536l1.414-1.415zm-2.12-4.95l1.34-1.34l.707.707l1.415-1.414l-8.486-8.485l-1.414 1.414l.707.707l-1.34 1.34z" />
                    </svg>
                  </div>
                </div>
                }
              </div>
              }
              }
              <div class="chat-box-container" [class.with-pinned-messages]="
                    pinnedMessages && pinnedMessages.length > 0
                  " [class.has-open-menu]="!!activeMessageMenuId" #singleScrollContainer
                (scroll)="onSingleChatScroll($event)" id="singleChatContainer" (drop)="onDrop($event)"
                (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
                @if (isInitialLoadingChat || chatLoader) {
                <div class="chat-feedback-state chat-loading-state">
                  <div class="chat-loading-spinner">
                    <span class="spinner-circle"></span>
                  </div>
                  <!-- <p class="feedback-title">Loading messages...</p>
                  <p class="feedback-desc">Please wait while we fetch the conversation.</p> -->
                </div>
                } @else if (chatLoadingError) {
                <div class="chat-feedback-state chat-error-state">
                  <div class="feedback-icon error-icon">
                    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  </div>
                  <p class="feedback-title">Unable to load messages</p>
                  <p class="feedback-desc">{{ chatLoadingError }}</p>
                  <button type="button" class="chat-retry-btn" (click)="retryCurrentChat()">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M23 4v6h-6"></path>
                      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                    </svg>
                    Tap to Retry
                  </button>
                </div>
                } @else if (singleChatMessages && singleChatMessages.length === 0) {
                <div class="chat-feedback-state chat-empty-state">
                  <div class="feedback-icon empty-icon">
                    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor"
                      stroke-width="1.8">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </div>
                  <p class="feedback-title">No messages yet</p>
                  <p class="feedback-desc">Send a message to start the conversation.</p>
                </div>
                }
                @if (hasActivity(singleChatMessages)) {
                <div class="activity-filter"
                  title="Hide a module's update lines in this chat (only for you, on this device)">
                  <span class="material-symbols-outlined">filter_list</span>
                  <span class="af-label">Updates from</span>
                  @for (k of activityKinds; track k.id) {
                  <button type="button" class="af-chip" [class.off]="hiddenActivity[k.id]"
                    (click)="toggleActivity(k.id)"
                    [title]="hiddenActivity[k.id] ? 'Show ' + k.label + ' lines' : 'Hide ' + k.label + ' lines'">{{
                    k.label }}</button>
                  }
                  @if (hiddenActivityCount(singleChatMessages); as n) { <span class="af-hidden">{{ n }} hidden</span>
                  }
                </div>
                }
                <div id="chat-messages"
                  [class.invisible-during-load]="singleChatMessages && singleChatMessages.length > 0 && !scrollReadySingle">
                  @for (message of singleChatMessages; track (message._id || message.id || message.messageId || i);
                  let
                  i = $index) {
                  @if (!isHiddenActivity(message)) {
                  <app-chat-message-item [message]="message" [userId]="userId" [chatMap]="chatMap"
                    [userNameMapping]="userNameMapping" [profileImageMapping]="profileImageMapping"
                    [pinnedMessages]="pinnedMessages" [starredMessages]="starredMessages"
                    [activeMessageMenuId]="activeMessageMenuId" [isMobileView]="isMobileView" [showcount]="showcount"
                    [commonReactions]="commonReactions" [reactingToMessageId]="reactingToMessageId"
                    [isGroupChat]="false" [uploadProgress]="uploadProgress" [channelId]="singleUser.channelId"
                    (reply)="replyToMessage($event)" (forward)="openForwardModal($event)" (edit)="editMessage($event)"
                    (delete)="deleteMessageAction($event.message, $event.forEveryone)" (pin)="pinMessageAction($event)"
                    (unpin)="unpinMessageAction($event)" (star)="addStarMessageAction($event)"
                    (unstar)="unStarMessageAction($event)"
                    (reaction)="onQuickReactionSelect($event.emoji, $event.messageId)"
                    (scrollToMessage)="scrollToMessage($event)" (fullReactionPicker)="openFullReactionPicker($event)"
                    (toggleMenu)="toggleMessageMenu($event.messageId, $event.messageObj)"
                    (openReactionDetails)="openReactionDetails($event)" (seenInfo)="openSeenInfoModal($event)"
                    (alertClick)="onSystemMessageClick($event.event, $event.message)"
                    (userMentionClick)="onUserMentionClick($event)" (allMentionClick)="onAllMentionClick()"
                    (memberClick)="onMemberClick($event)" (replyPrivately)="onReplyPrivately($event)"
                    (makeTask)="makeTaskFromMessage($event)">
                  </app-chat-message-item>
                  }
                  }
                </div>

                <!-- Drag and drop overlay -->
                @if (isDragOver) {
                <div class="drag-drop-overlay" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                  (dragleave)="onDragLeave($event)">
                  <div class="drag-drop-content">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11.9707 12V15.5C11.9707 17.43 13.5407 19 15.4707 19C17.4007 19 18.9707 17.43 18.9707 15.5V10C18.9707 6.13 15.8407 3 11.9707 3C8.1007 3 4.9707 6.13 4.9707 10V16C4.9707 19.31 7.6607 22 10.9707 22"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h4>Drop files here to upload</h4>
                    <p>Supported files: Images, Videos, Documents</p>
                  </div>
                </div>
                }
                @if (
                MetaDataDetails &&
                MedataLength > 0 &&
                MetaDataDetails.fileUrl &&
                isSuggestionBoxVisible
                ) {
                <ul class="filter-data">
                  <svg (click)="closeSuggestionBox()" class="meta-close" xmlns="http://www.w3.org/2000/svg" width="48"
                    height="48" viewBox="0 0 48 48">
                    <g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
                      <path d="M8 8L40 40" />
                      <path d="M8 40L40 8" />
                    </g>
                  </svg>
                  <p>
                    <b>Versions shared:</b>
                    {{ MetaDataDetails.fileName }}
                  </p>
                  @if (
                  MetaDataDetails.thread &&
                  MetaDataDetails.thread.length > 0
                  ) {
                  <ul class="sub-file">
                    @for (
                    threadItem of MetaDataDetails.thread;
                    track threadItem;
                    let j = $index
                    ) {
                    <li class="d-flex" (click)="
                                selectSuggestion(
                                  MetaDataDetails.fileUrl,
                                  MetaDataDetails._id
                                )
                              ">
                      <b>Version - {{ j + 1 }}:</b>
                      <!-- {{ MetaDataDetails.fileUrl }} -->
                      <span class="d-block" style="font-weight: 500; padding-left: 12px">sent at :
                        {{
                        threadItem.createdAt
                        | date: "hh:mm a - MMM d, y"
                        }}</span>
                    </li>
                    }
                  </ul>
                  }
                </ul>
                }

                <div class="chat-wrapper" style="height: 1px; width: 100%"></div>
              </div>

              <!-- Sits on the input's top edge, so a reply/edit preview pushes it up instead of hiding its close button -->
              @if (showJumpToLatestSingle) {
              <div class="jump-to-latest-anchor">
                <button class="jump-to-latest-btn" (click)="scrollToBottomSmooth()" aria-label="Scroll to latest message">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M11 6v8l-3.5-3.5l-1.42 1.42L12 17.84l5.92-5.92l-1.42-1.42L13 14V6zm1 16A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10" />
                  </svg>
                </button>
              </div>
              }
              <!-- Message Input -->
              <app-message-input #singleMessageInput [message]="newMessage" [replyingTo]="replyingToMessage"
                [editingMessage]="editingMessage" [showEmojiPicker]="showEmojiPicker" [showGifPanel]="showGifPanel"
                [selectedGifUrl]="selectedGifUrl" [isGroup]="false" [userId]="userId" [isSending]="isSending"
                [isMobileView]="isMobileView" (messageSent)="sendChatMessage($event)"
                (fileAttached)="handleFileInput($event)" (cameraOpened)="showCamera = true"
                (gifSelected)="selectGif($event)" (replyCancelled)="cancelReply()" (editCancelled)="cancelEdit()"
                (inputChanged)="onInputChange()" (pasteAction)="onPaste($event, 'single')"
                (emojiToggle)="toggleEmojiPicker()" (gifToggle)="toggleGifPanel()"
                (messageChange)="onSingleMessageChange($event)" (typingStart)="sendTypingStart()"
                (typingStop)="sendTypingStop()" (editLastMessage)="editLastSentMessage()">
              </app-message-input>
            </div>


          </div>
          }

          <!-- GROUP CHAT BOX CONTAINER -->
          @if (groupChatBox && (!showAdvancedSearchResults || isMobileView) && !showStarredMessages) {
          <div class="common-mg group-chat">
            <app-chat-header [title]="groupChatName" [image]="groupChatProfileImg" [isGroup]="true"
              [connectionStatus]="chatConnectionStatus" [memberDisplayNames]="groupMembersDisplayNames"
              [totalMembers]="totalGroupMembers" [showClickForInfo]="showClickForInfo" [isExited]="isCurrentGroupExited"
              [showMenu]="showChatMenuDropdown" [hasMessages]="groupChatMessages && groupChatMessages.length > 0"
              [isAdmin]="groupInfoPanel.isAdmin(userId)" [isLinkAdmin]="groupInfoPanel.isLinkAdmin" [typingUsers]="getCurrentTypingUsers()"
              [showSearchBackButton]="isLastNavAdvancedSearch || isNavigatedFromStarred"
              (searchBack)="handleSearchBack()" (back)="showBackButton()" (toggleMenu)="toggleChatWindowMenu()"
              (openInfo)="openGroupInfoModal()" (clearChat)="groupInfoPanel.clearChat()"
              (exitGroup)="groupInfoPanel.exitGroup()" (deleteGroup)="groupInfoPanel.deleteGroupChat()" (removeGroup)="groupInfoPanel.removeFromMyChats()"
              (starredClick)="toggleStarredMessagesPanel()" (quickSearch)="toggleQuickSearch()"
              (exportChat)="exportChatHistory($event)">
            </app-chat-header>
            <div class="chat-content">
              <!-- Group Chat Box -->
              <!-- Pinned Messages Header (Group) -->
              @if (pinnedMessages && pinnedMessages.length > 0) {
              @if (!showPinnedMessages) {
              <div class="pinned-messages-bar" (click)="togglePinnedMessages()">
                <div style="display: flex; align-items: center; gap: 10px; overflow: hidden;">
                  <span style="font-size: 16px" (click)="togglePinnedMessages()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                      <path fill="#dc3545" d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2z" />
                    </svg>
                  </span>
                  <div style="display: flex; flex-direction: column">
                    <span style="font-weight: bold; font-size: 12px; color: #008069;">
                      {{ pinnedMessages.length }} Pinned Message{{ pinnedMessages.length > 1 ? "s" : "" }}
                    </span>
                    @if (getPinnedMessageText(pinnedMessages[pinnedMessages.length - 1]) === '🎤 Voice message') {
                    <span
                      style="font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px; color: #3b4a54; display: flex; align-items: center; gap: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" style="color: #25D366;">
                        <path fill="currentColor"
                          d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path fill="currentColor"
                          d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                      Voice message {{ getVoiceDuration(pinnedMessages[pinnedMessages.length - 1]) }}
                    </span>
                    } @else {
                    <span
                      style="font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 250px; color: #3b4a54;">
                      {{ getPinnedMessageText(pinnedMessages[pinnedMessages.length - 1]) }}
                    </span>
                    }
                  </div>
                </div>
                <div style="font-size: 12px; color: #666; display: flex; align-items: center; gap: 5px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
                    <path fill="#000000" d="m7 10l5 5l5-5z" />
                  </svg>
                </div>
              </div>
              }

              @if (showPinnedMessages) {
              <div class="pinned-list">
                <div class="pinned-close"
                  style="position: sticky; top: 0; float: right; margin: 5px; padding: 2px; cursor: pointer; z-index: 1002; background: #eee; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;"
                  (click)="togglePinnedMessages(); $event.stopPropagation()" title="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#666" viewBox="0 0 16 16">
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </div>
                @for (msg of pinnedMessages; track msg) {
                <div
                  style="padding: 10px; border-bottom: 1px solid #eee; cursor: pointer; display: flex; justify-content: space-between; align-items: center; clear: right;"
                  (click)="scrollToMessage(getPinnedMessageId(msg))">
                  <div>
                    @if (getPinnedMessageText(msg) === '🎤 Voice message') {
                    <div class="pin-txt"
                      style="font-size: 12px; color: #333; display: flex; align-items: center; gap: 4px;">
                      <svg viewBox="0 0 24 24" width="14" height="14" style="color: #25D366;">
                        <path fill="currentColor"
                          d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path fill="currentColor"
                          d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                      Voice message {{ getVoiceDuration(msg) }}
                    </div>
                    } @else {
                    <div class="pin-txt" style="font-size: 12px; color: #333">{{ getPinnedMessageText(msg) }}</div>
                    }
                    <div style="font-size: 10px; color: #999">{{ msg.createdAt | date: "shortTime" }}</div>
                  </div>
                  <div (click)="unpinMessageAction(msg); $event.stopPropagation()" style="padding: 5px; color: #666"
                    title="Unpin">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                      <path fill="#dc3545"
                        d="m20.971 17.172l-1.414 1.414l-3.535-3.535l-.073.074l-.707 3.535l-1.415 1.415l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243l1.414-1.414l3.536-.707l.073-.074l-3.536-3.536l1.414-1.415zm-2.12-4.95l1.34-1.34l.707.707l1.415-1.414l-8.486-8.485l-1.414 1.414l.707.707l-1.34 1.34z" />
                    </svg>
                  </div>
                </div>
                }
              </div>
              }
              }
              <div class="chat-box-container px-4 " [class.with-pinned-messages]="
                    pinnedMessages && pinnedMessages.length > 0
                  " [class.has-open-menu]="!!activeMessageMenuId" #scrollContainer (scroll)="onGroupChatScroll($event)"
                id="groupChatContainer" (dragover)="onGroupDragOver($event)" (dragleave)="onGroupDragLeave($event)"
                (drop)="onGroupDrop($event)" [class.drag-active]="isGroupDragOver">
                @if (isInitialLoadingChat || chatLoader) {
                <div class="chat-feedback-state chat-loading-state">
                  <div class="chat-loading-spinner">
                    <span class="spinner-circle"></span>
                  </div>
                  <!-- <p class="feedback-title">Loading messages...</p>
                  <p class="feedback-desc">Please wait while we fetch the conversation.</p> -->
                </div>
                } @else if (chatLoadingError) {
                <div class="chat-feedback-state chat-error-state">
                  <div class="feedback-icon error-icon">
                    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  </div>
                  <p class="feedback-title">Unable to load messages</p>
                  <p class="feedback-desc">{{ chatLoadingError }}</p>
                  <button type="button" class="chat-retry-btn" (click)="retryCurrentChat()">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M23 4v6h-6"></path>
                      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                    </svg>
                    Tap to Retry
                  </button>
                </div>
                } @else if (groupChatMessages && groupChatMessages.length === 0) {
                <div class="chat-feedback-state chat-empty-state">
                  <div class="feedback-icon empty-icon">
                    <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor"
                      stroke-width="1.8">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <p class="feedback-title">No messages in this group yet</p>
                  <p class="feedback-desc">Send a message to start chatting with group members.</p>
                </div>
                }
                @if (hasActivity(groupChatMessages)) {
                <div class="activity-filter"
                  title="Hide a module's update lines in this chat (only for you, on this device)">
                  <span class="material-symbols-outlined">filter_list</span>
                  <span class="af-label">Updates from</span>
                  @for (k of activityKinds; track k.id) {
                  <button type="button" class="af-chip" [class.off]="hiddenActivity[k.id]"
                    (click)="toggleActivity(k.id)"
                    [title]="hiddenActivity[k.id] ? 'Show ' + k.label + ' lines' : 'Hide ' + k.label + ' lines'">{{
                    k.label }}</button>
                  }
                  @if (hiddenActivityCount(groupChatMessages); as n) { <span class="af-hidden">{{ n }} hidden</span> }
                </div>
                }
                <div id="chat-messages position-relative"
                  [class.invisible-during-load]="groupChatMessages && groupChatMessages.length > 0 && !scrollReady">
                  @for (message of groupChatMessages; track (message._id || message.id || message.messageId || i); let
                  i
                  = $index) {
                  @if (!isHiddenActivity(message)) {
                  <app-chat-message-item [message]="message" [userId]="userId" [chatMap]="chatMap"
                    [userNameMapping]="userNameMapping" [profileImageMapping]="profileImageMapping"
                    [pinnedMessages]="pinnedMessages" [starredMessages]="starredMessages"
                    [activeMessageMenuId]="activeMessageMenuId" [isMobileView]="isMobileView" [showcount]="showcount"
                    [commonReactions]="commonReactions" [reactingToMessageId]="reactingToMessageId" [isGroupChat]="true"
                    [isNoLongerMember]="isCurrentGroupExited" [uploadProgress]="uploadProgress2"
                    [channelId]="memberChannelId" (reply)="replyToMessage($event)" (forward)="openForwardModal($event)"
                    (edit)="editMessage($event)" (delete)="deleteMessageAction($event.message, $event.forEveryone)"
                    (pin)="pinMessageAction($event)" (unpin)="unpinMessageAction($event)"
                    (star)="addStarMessageAction($event)" (unstar)="unStarMessageAction($event)"
                    (reaction)="onQuickReactionSelect($event.emoji, $event.messageId)"
                    (scrollToMessage)="scrollToMessage($event)" (fullReactionPicker)="openFullReactionPicker($event)"
                    (toggleMenu)="toggleMessageMenu($event.messageId, $event.messageObj)"
                    (openReactionDetails)="openReactionDetails($event)" (seenInfo)="openSeenInfoModal($event)"
                    (alertClick)="onSystemMessageClick($event.event, $event.message)"
                    (userMentionClick)="onUserMentionClick($event)" (allMentionClick)="onAllMentionClick()"
                    (memberClick)="onMemberClick($event)" (replyPrivately)="onReplyPrivately($event)"
                    (makeTask)="makeTaskFromMessage($event)">
                  </app-chat-message-item>
                  }
                  }

                  <div class="chat-wrapper" style="height: 1px; width: 100%"></div>
                </div>

                <!-- Drag and drop overlay -->
                @if (isGroupDragOver) {
                <div class="drag-drop-overlay" (drop)="onGroupDrop($event)" (dragover)="onGroupDragOver($event)"
                  (dragleave)="onGroupDragLeave($event)">
                  <div class="drag-drop-content">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11.9707 12V15.5C11.9707 17.43 13.5407 19 15.4707 19C17.4007 19 18.9707 17.43 18.9707 15.5V10C18.9707 6.13 15.8407 3 11.9707 3C8.1007 3 4.9707 6.13 4.9707 10V16C4.9707 19.31 7.6607 22 10.9707 22"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h4>Drop files here to upload</h4>
                    <p>Supported files: Images, Videos, Documents</p>
                  </div>
                </div>
                }
              </div>

              <!-- @if (showMentionList) {
              <div class="mention-dropdown">
                @for (
                user of mentionUsers
                | chatSort: mentionSearchTerm : "userName";
                track user.userId
                ) {
                @if (user.userId !== userId) {
                <div class="mention-item" tabindex="0" (click)="selectMention(user)">
                  <img [src]="user.profileImage" (error)="handleProfileImageError($event)" class="mention-avatar"
                    width="30" height="30" />
                  <span style="font-size: 14px; font-weight: 500">
                    {{ user.name || user.displayName }}
                  </span>
                </div>
                }
                }
              </div>
              } -->
              @if (
              MetaDataDetails2 &&
              MedataLength2 > 0 &&
              MetaDataDetails2.fileUrl &&
              isSuggestionBoxVisible2
              ) {
              <ul class="filter-data group">
                <svg (click)="closeSuggestionBox2()" class="meta-close" xmlns="http://www.w3.org/2000/svg" width="48"
                  height="48" viewBox="0 0 48 48">
                  <g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
                    <path d="M8 8L40 40" />
                    <path d="M8 40L40 8" />
                  </g>
                </svg>
                <p>
                  <b>Versions shared:</b>
                  {{ MetaDataDetails2.fileName }}
                </p>
                @if (
                MetaDataDetails2.thread &&
                MetaDataDetails2.thread.length > 0
                ) {
                <ul class="sub-file">
                  @for (
                  threadItem of MetaDataDetails2.thread;
                  track threadItem;
                  let j = $index
                  ) {
                  <li class="d-flex" (click)="
                              selectSuggestion(
                                MetaDataDetails2.fileUrl,
                                MetaDataDetails2._id
                              )
                            ">
                    <b>Version - {{ j + 1 }}:</b>
                    <!-- {{ MetaDataDetails2.fileUrl }} -->
                    <span class="d-block" style="font-weight: 500; padding-left:12px">
                      sent by :
                      {{
                      userId === threadItem.senderId
                      ? "you"
                      : threadItem.senderName
                      }}
                      at :
                      {{
                      threadItem.createdAt
                      | date: "hh:mm a - MMM d, y"
                      }}
                    </span>
                  </li>
                  }
                </ul>
                }
              </ul>
              }

              <!-- Sits on the input's top edge, so a reply/edit preview pushes it up instead of hiding its close button -->
              @if (showJumpToLatest) {
              <div class="jump-to-latest-anchor">
                <button class="jump-to-latest-btn" (click)="scrollToBottomSmooth()" aria-label="Scroll to latest message">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M11 6v8l-3.5-3.5l-1.42 1.42L12 17.84l5.92-5.92l-1.42-1.42L13 14V6zm1 16A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10" />
                  </svg>
                </button>
              </div>
              }

              <!-- Message Input -->
              <app-message-input #groupMessageInput [message]="newGroupMessage" [replyingTo]="replyingToMessage"
                [editingMessage]="editingMessage" [showEmojiPicker]="showEmojiPicker" [showGifPanel]="showGifPanelGroup"
                [mentionUsers]="mentionUsers" [mentionSearchTerm]="mentionSearchTerm"
                [showMentionList]="showMentionList" [isGroup]="true" [selectedGifUrl]="selectedGifUrlGroup"
                [isExited]="isCurrentGroupExited" [userId]="userId" [isSending]="isSending"
                [isMobileView]="isMobileView" (messageSent)="sendGroupChatMessage($event)"
                (fileAttached)="handleGroupFileInput($event)" (cameraOpened)="showCamera = true"
                (gifSelected)="selectGifGroup($event)" (replyCancelled)="cancelReply()" (editCancelled)="cancelEdit()"
                (inputChanged)="onGroupInputChange($event)" (pasteAction)="onPaste($event, 'group')"
                (emojiToggle)="toggleEmojiPicker()" (gifToggle)="toggleGifPanelGroup()"
                (mentionSelected)="selectMention($event)" (messageChange)="onGroupMessageChange($event)"
                (typingStart)="sendTypingStart()" (typingStop)="sendTypingStop()"
                (editLastMessage)="editLastSentMessage()">
              </app-message-input>
            </div>
          </div>
          }
        </div>

        <!-- Right Side: Advanced Search Results (Desktop only) -->
        @if (!isMobileView && showAdvancedSearchResults) {
        <div class="col-md-3 search-results-side-panel px-0">
          <app-search-results [results]="advancedSearchResults" [matchesCount]="advancedSearchMatches"
            [filters]="advancedSearchFilters" [isLoading]="isSearchLoading" (selectChat)="onChatSelected($event)"
            (scrolled)="onSearchResultsScrolled()" (openPreview)="onOpenMediaPreview($event)"
            (closeResults)="closeAdvancedSearch()"></app-search-results>
        </div>
        }

      </div>
    </div>
    <!-- SIDE NAV PANEL -->
    <div class="side-nav" [class.open]="sideNavOpen">
      <button type="button" class="close-btn" (click)="toggleSideNav()">
        <i class="fa fa-times"></i>
      </button>

      <div class="side-nav-header">
        <img [src]="profileImg" alt="dp" class="side-nav-avatar" />
        <span>Hi {{ username }}!</span>
      </div>

      <div class="side-nav-item mt-3" (click)="installPWA()">
        <svg class="download-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 448 512">
          <path fill="currentColor"
            d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v210.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7zM64 320c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64h-46.9l-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320zm304 56a24 24 0 1 1 0 48a24 24 0 1 1 0-48" />
        </svg>
        <p class="mb-0">PWA</p>
      </div>

      <div class="side-nav-item mt-3" (click)="toggleStarredMessages(); toggleSideNav()">
        <svg style="color: #ffbc00" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor"
            d="m12 17.27l4.15 2.51l-1.1-4.73L18.5 11.7l-4.77-.41L12 7l-1.73 4.29l-4.77.41l3.45 3.37l-1.1 4.73z" />
        </svg>
        <p class="mb-0">Starred Messages</p>
      </div>

      <div class="side-nav-divider"></div>

      <div class="side-nav-item">
        <button class="btn logout-btn w-100" (click)="onClickLogout()">
          Logout
        </button>
      </div>
    </div>

    <div class="side-nav-backdrop" [class.show]="sideNavOpen" (click)="toggleSideNav()"></div>



    <!-- GROUP / CHAT INFO SIDE PANEL -->
    <app-group-info-panel #groupInfoPanel [isGroupInfoOpen]="isGroupInfoOpen" [userId]="userId" [isGroup]="groupChatBox"
      [singleUser]="singleUser" [singleChatUsername]="singleChatUsername" [singleUserProfileImg]="singleUserProfileImg"
      [chatUserStatus]="chatUserStatus" [isChatUserOnline]="isChatUserOnline"
      [chatMessages]="singleChatBox ? singleChatMessages : groupChatMessages"
      [activeChannelId]="singleChatBox ? activeChannel : memberChannelId" [memberChannelId]="memberChannelId"
      [groupName]="groupName" [groupChatName]="groupChatName" [groupChatDescription]="groupChatDescription"
      [groupChatProfileImg]="groupChatProfileImg" [allGroupMembers]="allGroupMembers"
      [totalGroupMembers]="totalGroupMembers" [exitedGroups]="exitedGroups"
      (isGroupInfoOpenChange)="isGroupInfoOpen = $event" (allGroupMembersChange)="onAllGroupMembersChange($event)"
      (exitedGroupsChange)="exitedGroups = $event" (startSingleChat)="startSingleChat($event)"
      (closeGroupInfoPanelEvent)="closeGroupInfoPanel()" (groupNameChange)="groupName = $event"
      (groupChatNameChange)="groupChatName = $event" (groupChatDescriptionChange)="groupChatDescription = $event"
      (groupChatProfileImgChange)="groupChatProfileImg = $event" (chatCleared)="onGroupChatCleared()"
      (groupExited)="onGroupExited($event)" (groupDeleted)="onGroupDeleted($event)"
      (mediaClick)="openImageModal($event.message, $event.index)" (clearSingleChat)="clearChat()">
    </app-group-info-panel>

    <!-- STARRED MESSAGES SIDE PANEL -->
    <app-starred-messages-panel [isOpen]="isStarredMessagesPanelOpen" [userId]="userId"
      [channelId]="activeChannel || memberChannelId" [userNameMapping]="userNameMapping"
      [profileImageMapping]="profileImageMapping" [chatMap]="chatMap" (closePanel)="isStarredMessagesPanelOpen = false"
      (messageSelected)="goToStarredMessage($event); isStarredMessagesPanelOpen = false"
      (unstarMessage)="unStarMessageAction($event)">
    </app-starred-messages-panel>

    <!-- QUICK SEARCH SIDE PANEL -->
    <app-quick-search #quickSearchComp [isOpen]="isQuickSearchOpen" [chatId]="currentChatIdForSearch"
      [chatType]="groupChatBox ? 'group' : 'single'" [chatTitle]="groupChatBox ? groupChatName : singleChatUsername"
      [userId]="userId" [userNameMapping]="userNameMapping" [profileImageMapping]="profileImageMapping"
      [isDarkMode]="isDarkMode" (closePanel)="closeQuickSearch()"
      (messageSelected)="onQuickSearchMessageSelected($event)">
    </app-quick-search>

    <!-- NOTIFICATION SETTINGS SIDE PANEL -->
    <app-notification-settings-panel [isOpen]="isNotificationSettingsOpen"
      [channelId]="memberChannelId || activeChannel" (closePanel)="isNotificationSettingsOpen = false">
    </app-notification-settings-panel>

    <!-- MENTION ALL MODAL -->
    @if (showMentionAllModal) {
    <div class="mention-all-modal-overlay" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode"
      (click)="closeMentionAllModal()">
      <div class="mention-all-modal" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode"
        (click)="$event.stopPropagation()">
        <h3 class="mention-all-modal-title">Mention all</h3>
        <p class="mention-all-modal-desc">
          Notify all members of an important message. You can mute &#64;all in
          <a class="mention-all-settings-link" (click)="openNotificationSettingsFromModal($event)">notification
            settings</a>.
        </p>
        <div class="mention-all-modal-actions">
          <button type="button" class="mention-all-close-btn" (click)="closeMentionAllModal()">Close</button>
        </div>
      </div>
    </div>
    }

    <!-- CREATE GROUP MODAL -->
    @if (showCreateGroupModal) {
    <app-create-group-modal [userId]="userId" [senderUsername]="senderUsername" [profileImg]="profileImg"
      (closeCreateGroupModalEvent)="closeCreateGroupModal()" (groupCreated)="onGroupCreated($event)">
    </app-create-group-modal>
    }


    <!-- REACTION PICKER MODAL -->
    @if (showReactionEmojiPicker) {
    <div class="reaction-picker-overlay" (click)="closeReactionPicker()">
      <div class="reaction-picker-content" (click)="$event.stopPropagation()">
        <emoji-mart [emojiSize]="24" [perLine]="8" [showPreview]="false" [enableSearch]="true"
          (emojiClick)="onReactionSelect($event)" [skin]="1" [color]="'#00a884'" title=""></emoji-mart>
      </div>
    </div>
    }

    <!-- Reaction Details Modal -->
    @if (showReactionDetailsModal) {
    <div class="reaction-details-modal-overlay" (click)="closeReactionDetails()">
      <div class="reaction-details-modal" (click)="$event.stopPropagation()">
        <div class="reaction-modal-header">
          <div class="reaction-header-title">Message Reactions</div>
          <button class="reaction-close-btn" (click)="closeReactionDetails()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <!-- Tabs -->
        <div class="reaction-tabs">
          @for (tab of reactionTabs; track tab.label) {
          <div class="reaction-tab-item" [class.active]="activeReactionTab === tab.label"
            (click)="switchReactionTab(tab.label)">
            @if (tab.emoji) {
            <span class="tab-emoji">{{ tab.emoji }}</span>
            }
            @if (tab.label === "All") {
            <span class="tab-label">All</span>
            }
            <span class="tab-count">{{ tab.count }}</span>
          </div>
          }
        </div>

        <!-- List -->
        <div class="reaction-users-list">
          @for (
          item of filteredReactionDetails;
          track item.userId + item.emoji
          ) {
          <div class="reaction-user-item" [class.clickable]="item.userId === userId"
            (click)="item.userId === userId ? removeSelfReaction(item) : null">
            <div class="d-flex align-items-center justify-content-between w-100">
              <div class="user-avatar-wrapper d-flex align-items-center">
                <img [src]="item.userImage" alt="" class="user-avatar" (error)="handleProfileImageError($event)" />
                <div class="d-flex flex-column">
                  <span class="user-name ml-3">{{
                    item.userName
                    }}</span>
                  @if(item.userId === userId){
                  <span class="click-to-remove ml-3" style="font-size: 11px; color: #ff4d4f; font-weight: 500;">Click
                    to
                    remove</span>
                  }
                </div>
              </div>
              <div class="user-info-col ml-3 d-flex flex-column justify-content-center">
                <div class="d-flex align-items-center">
                  <div class="d-flex flex-column align-items-end">
                    <span class="reaction-emoji-inline ml-2">{{
                      item.emoji
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <!-- FORWARD MESSAGE MODAL -->
    @if (showForwardModal) {
    <app-forward-modal [visible]="showForwardModal" [message]="forwardingMessage?.message || ''"
      [files]="forwardingMessage?.files || []" [meta]="forwardingMessage?.meta" [chats]="filteredForwardChats"
      [currentChatId]="activeChannel || memberChannelId" [userId]="userId" (close)="closeForwardModal()"
      (forward)="sendForward($event); closeForwardModal()"></app-forward-modal>
    }

    <!-- SEEN INFO MODAL -->
    @if (showSeenInfoModal) {
    <app-message-seen-info-modal [visible]="showSeenInfoModal" [seenMembers]="seenInfoMembers"
      [totalMembers]="seenInfoTotalMembers" (close)="closeSeenInfoModal()"></app-message-seen-info-modal>
    }

    <!-- CAMERA CAPTURE -->
    <app-camera-capture [visible]="showCamera" (captured)="handleCameraCapture($event)"
      (closed)="onCameraClosed()"></app-camera-capture>
  </div>

</div>